import { Pipe, PipeTransform } from "@angular/core";
import { BeaconDTO } from "../beacons/Beacon";

@Pipe({ name: 'beaconFilter' })
export class BeaconFilterPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {any[]} items
   * @param {string} searchText
   * @returns {any[]}
   */
  transform(items: BeaconDTO[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      return it.name.toLocaleLowerCase().includes(searchText);
    });
  }
}